module.exports = __webpack_public_path__ + "static/media/32@2x.341571dc.png";